var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","data-ifPC":String(_vm.ifPC)}},[(_vm.ifPC)?_c('el-container',[_c('Header'),_vm._v(" "),_c('keep-alive',[_c('router-view')],1),_vm._v(" "),_c('el-footer',[_c('Footer')],1)],1):_c('el-container',[_c('h5-header'),_vm._v(" "),_c('keep-alive',[_c('router-view')],1),_vm._v(" "),_c('h5-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12c89c75","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/fastclass-loader!./src/App.vue
// module id = null
// module chunks = 